module.exports = __webpack_public_path__ + "static/img/19.12b784b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/eng/19.png
// module id = j5DJ
// module chunks = 0